<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">消费提成</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">消费提成列表</div>
      </div>
      <div class="panel-body clearfix">

        <el-table :data="billList" highlight-current-row show-header v-loading="listLoading" class="table-empty" style="width: 100%;">
          <el-table-column prop="userName" label="用户姓名" min-width="150" align="left">

          </el-table-column>
          <el-table-column prop="ID_Mobile" label="手机号码" min-width="150" align="left">

          </el-table-column>
          <el-table-column prop="product_id" label="产品编号" min-width="100" align="left">
          </el-table-column>
          <el-table-column prop="product_type" label="产品类型" min-width="100" align="left">

          </el-table-column>
          <el-table-column prop="StartTime" label="开始时间" min-width="150" align="left">

          </el-table-column>
          <el-table-column prop="EndTime" label="结束时间" align="left" min-width="150">

          </el-table-column>
          <el-table-column prop="caiwu_money" label="消费金额" align="center" min-width="100">

          </el-table-column>
          <el-table-column prop="ticheng_money" label="提现金额" align="left" min-width="100">
          </el-table-column>
          <el-table-column prop="btn" label="提现" align="left" min-width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="Tixian(scope.row.product_id,scope.row.product_type)">提现</el-button>
            </template>
          </el-table-column>
          <span slot="empty">
            消费提成列表为空
          </span>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import VpsService from 'business/VpsService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import userService from 'business/userService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        billList:[],
        dialogLoading:false,
        listLoading:false,
        dialogXufei:false,
        dialogXLevel:false,
        dialogEditname:false,
        dialogEditBeizhu:false,
        dialogShadow:false,
        errorMsg:'',
        activeNames:'index',
        input:'',
        userList: [],
        count:10,
        total:0,
        page:1,
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchBill()
    },
    computed: {

    },
    watch:{

    },
    methods:{
      async SearchBill() {
        this.listLoading = true
        let data = 'cmd=xiaofei_ticheng'+
          '&count='+ this.count +
          '&page='+ this.page
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=xiaofei_ticheng')
        if(vueData) {
          this.total = vueData.msg.allcount
          this.billList = vueData.msg.content
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchBill()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchBill()
      },
      async Tixian(id,type) {
        this.dialogLoading = true
        let data = 'cmd=tixian_ticheng'+
          '&product_id='+ id +
          '&product_type='+ type
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.SearchBill()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .xufei-form .el-input,.el-select {
    width: 140px;
  }
  .input-with-select .el-input-group__prepend .el-select {
    width: 100px;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .edit-name {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(../../assets/imgs/server_edit.png) no-repeat center;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .state-icon {
    padding-left: 22px;
    background: no-repeat left center;
  }
  .server-state-run {
    background-image: url(../../assets/imgs/server_state_run.png);
    color: #29cc7a;
  }
  .server-state-stop {
    background-image: url(../../assets/imgs/server_state_stop.png?v=2);
    color: #ff0000;
  }

  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>




// WEBPACK FOOTER //
// src/pages/caiwu/bill.vue